"use strict";

var _regeneratorRuntime = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(forEachObject),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(forEachMapping);

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var common_1 = require("../common");

var Controls = require("./controls");

exports.Controls = Controls;

__export(require("./chart_element"));

__export(require("./object"));

function findObjectById(spec, id) {
  if (spec._id == id) {
    return spec;
  }

  var obj = common_1.getById(spec.scales, id) || common_1.getById(spec.elements, id) || common_1.getById(spec.glyphs, id);

  if (obj != null) {
    return obj;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = spec.glyphs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var glyph = _step.value;
      obj = common_1.getById(glyph.marks, id);

      if (obj != null) {
        return obj;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

exports.findObjectById = findObjectById;

function forEachObject(chart) {
  var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chartElement, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, glyph, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, mark, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, scale;

  return _regeneratorRuntime.wrap(function forEachObject$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return {
            kind: "chart",
            object: chart
          };

        case 2:
          _iteratorNormalCompletion2 = true;
          _didIteratorError2 = false;
          _iteratorError2 = undefined;
          _context.prev = 5;
          _iterator2 = chart.elements[Symbol.iterator]();

        case 7:
          if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
            _context.next = 14;
            break;
          }

          chartElement = _step2.value;
          _context.next = 11;
          return {
            kind: "chart-element",
            object: chartElement,
            chartElement: chartElement
          };

        case 11:
          _iteratorNormalCompletion2 = true;
          _context.next = 7;
          break;

        case 14:
          _context.next = 20;
          break;

        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](5);
          _didIteratorError2 = true;
          _iteratorError2 = _context.t0;

        case 20:
          _context.prev = 20;
          _context.prev = 21;

          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }

        case 23:
          _context.prev = 23;

          if (!_didIteratorError2) {
            _context.next = 26;
            break;
          }

          throw _iteratorError2;

        case 26:
          return _context.finish(23);

        case 27:
          return _context.finish(20);

        case 28:
          _iteratorNormalCompletion3 = true;
          _didIteratorError3 = false;
          _iteratorError3 = undefined;
          _context.prev = 31;
          _iterator3 = chart.glyphs[Symbol.iterator]();

        case 33:
          if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
            _context.next = 66;
            break;
          }

          glyph = _step3.value;
          _context.next = 37;
          return {
            kind: "glyph",
            object: glyph,
            glyph: glyph
          };

        case 37:
          _iteratorNormalCompletion5 = true;
          _didIteratorError5 = false;
          _iteratorError5 = undefined;
          _context.prev = 40;
          _iterator5 = glyph.marks[Symbol.iterator]();

        case 42:
          if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
            _context.next = 49;
            break;
          }

          mark = _step5.value;
          _context.next = 46;
          return {
            kind: "mark",
            object: mark,
            glyph: glyph,
            mark: mark
          };

        case 46:
          _iteratorNormalCompletion5 = true;
          _context.next = 42;
          break;

        case 49:
          _context.next = 55;
          break;

        case 51:
          _context.prev = 51;
          _context.t1 = _context["catch"](40);
          _didIteratorError5 = true;
          _iteratorError5 = _context.t1;

        case 55:
          _context.prev = 55;
          _context.prev = 56;

          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }

        case 58:
          _context.prev = 58;

          if (!_didIteratorError5) {
            _context.next = 61;
            break;
          }

          throw _iteratorError5;

        case 61:
          return _context.finish(58);

        case 62:
          return _context.finish(55);

        case 63:
          _iteratorNormalCompletion3 = true;
          _context.next = 33;
          break;

        case 66:
          _context.next = 72;
          break;

        case 68:
          _context.prev = 68;
          _context.t2 = _context["catch"](31);
          _didIteratorError3 = true;
          _iteratorError3 = _context.t2;

        case 72:
          _context.prev = 72;
          _context.prev = 73;

          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }

        case 75:
          _context.prev = 75;

          if (!_didIteratorError3) {
            _context.next = 78;
            break;
          }

          throw _iteratorError3;

        case 78:
          return _context.finish(75);

        case 79:
          return _context.finish(72);

        case 80:
          _iteratorNormalCompletion4 = true;
          _didIteratorError4 = false;
          _iteratorError4 = undefined;
          _context.prev = 83;
          _iterator4 = chart.scales[Symbol.iterator]();

        case 85:
          if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
            _context.next = 92;
            break;
          }

          scale = _step4.value;
          _context.next = 89;
          return {
            kind: "scale",
            object: scale,
            scale: scale
          };

        case 89:
          _iteratorNormalCompletion4 = true;
          _context.next = 85;
          break;

        case 92:
          _context.next = 98;
          break;

        case 94:
          _context.prev = 94;
          _context.t3 = _context["catch"](83);
          _didIteratorError4 = true;
          _iteratorError4 = _context.t3;

        case 98:
          _context.prev = 98;
          _context.prev = 99;

          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }

        case 101:
          _context.prev = 101;

          if (!_didIteratorError4) {
            _context.next = 104;
            break;
          }

          throw _iteratorError4;

        case 104:
          return _context.finish(101);

        case 105:
          return _context.finish(98);

        case 106:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[5, 16, 20, 28], [21,, 23, 27], [31, 68, 72, 80], [40, 51, 55, 63], [56,, 58, 62], [73,, 75, 79], [83, 94, 98, 106], [99,, 101, 105]]);
}

exports.forEachObject = forEachObject;

function forEachMapping(mappings) {
  var _i, _Object$keys, key;

  return _regeneratorRuntime.wrap(function forEachMapping$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _i = 0, _Object$keys = Object.keys(mappings);

        case 1:
          if (!(_i < _Object$keys.length)) {
            _context2.next = 8;
            break;
          }

          key = _Object$keys[_i];
          _context2.next = 5;
          return [key, mappings[key]];

        case 5:
          _i++;
          _context2.next = 1;
          break;

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

exports.forEachMapping = forEachMapping;

function setProperty(object, property, value) {
  if (typeof property == "string") {
    object.properties[property] = value;
  } else {
    common_1.setField(object.properties[property.property], property.field, value);
  }
}

exports.setProperty = setProperty;

function getProperty(object, property) {
  if (typeof property == "string") {
    return object.properties[property];
  } else {
    return common_1.getField(object.properties[property.property], property.field);
  }
}

exports.getProperty = getProperty;